import { getBucket } from './getBucket';
import { getBucketCount } from './getBucketCount';
import { getBucketList } from './getBucketList';
import { getSelectedBucketCount } from './getSelectedBucketCount';
import { getSelectedBucketList } from './getSelectedBucketList';
import { isBucketListLoaded } from './isBucketListLoaded';

export const StorageBucketsSelectors = {
    getBucketList,
    getBucket,
    getBucketCount,
    getSelectedBucketList,
    getSelectedBucketCount,
    isBucketListLoaded,
};
